<template>
  <div class="search-results__none">
    <i class="icon-search" aria-hidden="true"></i>
    <p>
      Sorry, there were no results for your search<template v-if="searchTerm">
        "{{ searchTerm }}"</template
      >.<template v-if="isFiltering">
        Please try removing some filters to see more programmes.</template
      >
    </p>
    <search-clear-filters
      v-if="isFiltering"
      link-classes="button button--small bg-bright-blue"
    />
  </div>
</template>
<script>
export default {
  name: 'SearchNoResults',
  props: {
    isFiltering: Boolean,
    searchTerm: String,
  },
};
</script>
